import * as Sentry from "@sentry/react";
import { version } from "../../../package.json";

export function initSentry() {
  Sentry.init({
    dsn: process.env.EXPO_PUBLIC_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
    ],
    tracesSampleRate: 1.0,
    profilesSampleRate: 1.0,
    debug: false,
    enabled: process.env.EXPO_PUBLIC_ENVIRONMENT !== "development",
    environment: process.env.EXPO_PUBLIC_ENVIRONMENT ?? "development",
    release: `expo-app@${version}`,
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (
        error instanceof Error &&
        error.message.includes("Server Error") &&
        error.message.includes("[CONVEX Q(")
      ) {
        return null;
      }
      return event;
    },
  });
}
